import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { apiClient } from "../config/apiClient";
import { API } from "../config/apiConfig";
import { ResetBodyNetType } from "./NetTypes";

async function resetPasswordRequest({ newPassword, token }: ResetBodyNetType) {
	return await apiClient
		.post(API.AUTH.RESET_PASSWORD, { newPassword, token })
		.then((res) => res.data);
}

export function useResetPassword() {
	return useMutation<any, AxiosError, ResetBodyNetType>({
		mutationFn: (body: ResetBodyNetType) => {
			return resetPasswordRequest(body);
		}
	});
}
